module.exports = __webpack_public_path__ + "static/deanndeluca-af43dcdd1b820c6333b0345596f014c9.svg";